import { FlowInputId } from 'xm-constants/flowInput';

export const form = {
  name: 'CreateXmEventConferenceBridgeTabForm',
  // the "flowBlockInputName" property here is key to undertand how the "conference bridge" tab
  // works in the "Create Alert Using a Form" script step.
  // When the flowBlock editor is closed with a "save/done" action (as opposed to cancel)
  // the state of that flowBlock is saved to the redux store (despite the fact that we're working
  // with react-hook-form here).
  // When the canvas is saved the /flow-canvas endpoint is called with a payload that has an "inputs"
  // property among other things. This "inputs" array is created with all the form fields of all the
  // flowBlocks that make up the canvas.
  // Each element of that array has the ID of the flowBlock it belongs to and a value.
  // This value is used down the road to generate the "input" object that script executor
  // relies on at run-time to execute the step this flowBlock maps to.
  // That value is what we would tend to call a "flowBlockInput".
  // Here that value will be a stringified JSON that script executor will need to parse.
  // The content of that JSON is created on form submit,
  // using the values of the "form fields" of the flowBlock...

  // (!) "flowBlockInput"  !==  "input field on a flowBlock"
  // (!) "flowBlockInput"  !==  "form field in the flowBlock editor"
  // flowBlockInputs aren't always populated with form fields values
  // but form fields are always used to populate flowBlockInputs.

  // (!) Unfortunately, sometimes we refer to a "flowBlockInput" as a "flowBlock FIELD",
  // and that can be a source of confusion. See the "saveField" and "saveAllFields" in the
  // "useFlowBlockInputsAsFields" hook. It's a fair name in most cases, since most of the time
  // we have a 1 to 1 mapping of an "input field" to a "flowBlock input".
  // Same thing said differently: most of the time 1 input field react component ties to 1 property
  // on the "input" object that script executor receives at run-time.
  // (!) "input" !== "input field"
  // (!) "input field" !== "flowBlock input"
  // At time of writing these "input fields" are all controlled by react-hook-form, and their values
  // are used at form submit time to create the value of a SINGLE "flowBlock input".
  flowBlockInputName: 'conferenceBridge',
  fields: {
    bridgeTypeSelector: { name: 'bridgeTypeSelector' }, // (!) type selector vs type input
    bridgeTypeInput: { name: 'bridgeTypeInput' }, // (!) type selector vs type input
    externalBridgeSelector: { name: 'externalBridgeSelector' },
    bridgeIdOrNameInput: { name: 'bridgeIdOrNameInput' },
    bridgeNumberInput: { name: 'bridgeNumberInput' },
    bridgeMeetingLinkInput: { name: 'bridgeMeetingLinkInput' },
  },
};

export const fieldNameToFlowBlockInputName = {
  [form.flowBlockInputName]: FlowInputId.CONFERENCE_BRIDGE,
};

export const bridgeTypes = {
  XMATTERS_BRIDGES_ONLY: 'XMATTERS_BRIDGES_ONLY',
  EXTERNAL_BRIDGES_ONLY: 'EXTERNAL_BRIDGES_ONLY',
  XMATTERS_AND_EXTERNAL_BRIDGES: 'XMATTERS_AND_EXTERNAL_BRIDGES',
};

export const bridgeModes = {
  USE_OUTPUT_OR_CONSTANT: 'USE_OUTPUT_OR_CONSTANT',
};
